import { Column } from 'utils/models';
import { TableConfig } from 'models/general';
import { useAppContext } from 'context/hooks';
import { Table } from '@mantine/core';
import { ReactElement } from 'react';
import { TableHeaderItem } from './TableHeaderItem';
import { TableCheckBox } from '../TableBody/TableCheckbox';
import classes from '../Table.module.css';

interface Props<T> {
  columns: Column<T>[];
  config: TableConfig;
  selectable?: boolean;
  allRowIds?: string[];
  testId?: string;
}

export const TableHeader = <T,>({ columns, config, selectable, allRowIds, testId = '' }: Props<T>): ReactElement => {
  const { updateTableRowIds, selectedTableRowIds = [] } = useAppContext();
  const allChecked = selectedTableRowIds.length === allRowIds?.length;

  const handleSelected = () => {
    if (!updateTableRowIds || !allRowIds) {
      return;
    }

    updateTableRowIds(allChecked ? [] : allRowIds);
  };

  return (
    <Table className={classes.table}>
      <tbody>
        <tr data-testid={testId}>
          {selectable && (
            <td>
              <TableCheckBox onChange={() => handleSelected()} checked={allChecked} />
            </td>
          )}
          {columns.map((column: Column<T>, key: number) => (
            <TableHeaderItem key={key} data={column} config={config} />
          ))}
        </tr>
      </tbody>
    </Table>
  );
};
